export const TRANSACTION_DATE_COLUMN_NAME = 'transaction_date';
export const FINANCIAL_YEAR_COLUMN_SPECIAL_TYPE = 'financial_year';
export const FINANCIAL_PERIOD_COLUMN_SPECIAL_TYPE = 'financial_period';
